<template>
        <list
        :staticFilters="staticFilters"
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          :openItem="false"
          @input="change"
          @changeFunction="changeFunction"
          @deleted="$emit('deleted',true)"
          v-model="val"
        />
</template>
<script>
export default {
  name: "products",
props:{
  id: {
    default : null
  }
},
created() {
       this.itemLink =  `shops/${this.id}/users`;
      this.setLink = `shops/${this.id}/users`;
},
methods: {
    changeFunction(val) {},
    change(val) {
    },
 
  },
  data() {
    return {
      val: [],
          staticFilters: [
        ],
      modalCreate: "user",
      fields: [
           {
              label: "Выберите пользователя",
              key: "user",
              type: "select",
              modal: "user", 
              params:{role_code:'tp_admin'},
              selectKey: "name",
            }
      ],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "",
      setLink: "",
   columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
    
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "role",
          title: "Роль",
          object: "title",
          disableLink:true
        },
    
        {
          detail: false,
          remove: true,
        },
      ],
    };
  },
};
</script>
